import moment from "moment";
import { useNavigate } from "react-router-dom";
import { usePartnerData } from "../../../providers/partnerData";
import { IProfessional } from "./types";
import { Tooltip } from "@mui/material";

moment.locale("pt-br");

const ProfessionalPaymentInfos = ({
  appointment,
  scheduleInfos,
}: IProfessional) => {
  const navigate = useNavigate();

  const { partnerUrl } = usePartnerData();

  const { doctor, place, schedule, scheduleDetails } = scheduleInfos;

  console.log(place);

  const { image, gender, crm, name } = appointment ? appointment.specialistDoctor : doctor;
  const { type } = !!scheduleDetails && scheduleDetails;
  const price = (appointment && appointment.price > 0) ? appointment.price.toFixed(2) : ((place.price > 0 || place.telePrice > 0) ? type === "presencial" ? place.price.toFixed(2) : place.telePrice.toFixed(2) : null);

  //? 0 - Feminino, 1 - Masculino
  const doctorImage: string = image ? image : gender === 0 ? "https://conectadoc.com.br/ImgMedico/Thumbs/ThumbFemale.jpg" : "https://conectadoc.com.br/ImgMedico/Thumbs/ThumbMale.jpg";


  return (
    <div className="card text-body bg-light p-3 px-md-5 py-md-4 sticky-xl-top">
      <h5>
        Informações da {type === "presencial" ? "consulta" : "Teleconsulta"}
      </h5>
      <h6 className="text-muted text-uppercase small mt-2">Profissional:</h6>
      <div className="bg-white rounded-4 border p-3 pb-0 mb-4">
        <div className="row align-items-center">
          <div className="col col-auto pb-3 e-0">
            <div className="img-wrap" style={{ width: 60 }}>
              <img alt={`${doctor.gender === 0 ? "Dra." : "Dr."} ${doctor.name}`} src={doctorImage} />
            </div>
          </div>

          <div className="col-12 col-sm pb-3">
            <h6 className="text-primary mb-1 small">CRM: {crm}</h6>
            <h5 className="mb-1">
              {gender === 0 ? "Dra." : "Dr."} {name}
              <Tooltip title="Profissional Verificado">
                <i
                  className="las la-check-circle text-primary ms-2"
                ></i>
              </Tooltip>
            </h5>
            <h6 className="mb-0">
              {doctor?.specialty?.length ? doctor.specialty[0].name : ""}
            </h6>
          </div>
        </div>
      </div>

      <h6 className="text-muted text-uppercase small">
        Data e hora da {type === "presencial" ? "consulta" : "teleconsulta"}:
      </h6>
      <div className="bg-white rounded-4 border p-3 pb-0 mb-4">
        {appointment ? (
          <h5 className="text-center mb-3">
            {moment(new Date(appointment.date)).format("L")} -{" "}
            <span className="text-primary">
              {moment(
                `${appointment.scheduleTime.initialTimeHours}:${appointment.scheduleTime.initialTimeMinutes}`,
                "HH:mm"
              ).format("HH:mm")}
            </span>
          </h5>
        ) : (
          <h5 className="text-center mb-3">
            {moment(new Date(schedule.data)).format("L")} -{" "}
            <span className="text-primary">
              {schedule.agendas[0].timeStart}
            </span>
          </h5>
        )}
      </div>

      {type === "presencial" && (
        <>
          <h6 className="text-muted text-uppercase small">
            Local da consulta:
          </h6>
          <div className="bg-white rounded-4 border p-3 pb-0 mb-4">
            <h5 className="text-center mb-0">{place.name}</h5>
            <p className="text-center mb-3 small">
              {place.addressName}, {place.number}
            </p>
          </div>
        </>
      )}

      {price && (
        <>
          <h6 className="text-muted text-uppercase small">
            Valor da {type === "presencial" ? "consulta" : "teleconsulta"}:
          </h6>
          <div className="bg-white rounded-4 border p-3 pb-0 mb-4">
            <h4 className="text-center mb-3">
              R${" "}
              <span className="text-primary">
                {price}
              </span>
            </h4>
          </div>
        </>
      )}

      <h6 className="text-muted text-uppercase small">Convênio:</h6>
      <div className="bg-white rounded-4 border p-3 pb-0 mb-4">
        <h4 className="text-center mb-3 text-primary">
          {!appointment ? scheduleDetails.healtyInsurance.name : appointment.healthInsurance.name}
        </h4>
      </div>

      <div className="text-center">
        <button
          onClick={() =>
            navigate(`/${partnerUrl}/profissional`, {
              state: !appointment ? doctor.id : appointment.specialistDoctor.id,
            })
          }
          className="btn btn-outline-secondary"
        >
          {type === "presencial" ? "Alterar Data ou Local" : "Alterar Data"}
        </button>
      </div>
    </div>
  );
};

export default ProfessionalPaymentInfos;
